import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Beautifully%20manicured%20golf%20course%20fairway%20at%20dawn%2C%20single%20golf%20flag%20on%20a%20rolling%20green%2C%20misty%20pine%20forest%20backdrop%2C%20soft%20warm%20diffused%20morning%20light%2C%20cinematic%20painterly%20editorial%20photography%20style%2C%20deep%20emerald%20and%20warm%20gold%20colour%20palette%2C%20peaceful%20atmospheric%20composition%20suitable%20as%20call%20to%20action%20background&width=1800&height=900&seq=handicalc-cta-bg-v1&orientation=landscape"
            alt="Golf course fairway at dawn"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/70 to-primary-800/60"></div>

          <div className="relative z-10 px-6 md:px-14 py-16 md:py-24 text-center">
            <div className="text-background-50">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur border border-background-50/25 text-xs font-medium">
                <i className="ri-flag-line"></i> Ready when you are
              </span>
              <h2 className="mt-5 font-heading font-bold text-3xl md:text-5xl tracking-tight leading-tight max-w-3xl mx-auto">
                <a href="#cta">Get the right strokes — before the first tee.</a>
              </h2>
              <p className="mt-5 text-background-100/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
                Free, fast and accurate. 20+ formats including fourball, betterball, scrambles and match play. Mixed tees? Handled automatically. No sign-up, no spreadsheets, no charts — just the correct WHS™ shot allowance for every round.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/calculator"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors"
                >
                  Open HANDICALC® <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-background-50/10 hover:bg-background-50/20 backdrop-blur border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-colors"
                >
                  Read the FAQ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}